export const landingSectionFragment = `
  title
  hidden
  description
  options {
    title
    description
  }
`;
